var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { ElementInspector } from 'element-prompt-builder';
import { useRouting } from '@rad/hooks';
import { RequestError, addResponseInterceptor } from '@rad/utility/http';
import NotImplementedProvider from '@rad/components/utility/not-implemented-context';
import { ContextAuth } from './hooks/useAuth';
import { onSubdomain } from './common/routes';
import { useToast } from './contexts/toast';
import { SavedPropertiesProvider } from './contexts/saved-properties';
import { useAuthHelper, httpErrorMessage, getAvailableRoutes, findMatchingRoute, executeInvalidAccessHandler } from './_common';
const AppContent = (props) => {
    const [stateAuth, setToken, setContext] = useAuthHelper();
    const [routeCurrent, navigate] = useRouting();
    const toast = useToast();
    // The app tells the person about a failed request once, here. The request then rejects, and a
    // caller with nothing to put back leaves it uncaught, which is no error worth reporting again.
    useEffect(() => {
        const removeInterceptor = addResponseInterceptor((res, handled) => __awaiter(void 0, void 0, void 0, function* () {
            if (res.status === 401)
                props.routingConfig.on401();
            else if (!res.ok && !handled)
                toast.error(yield httpErrorMessage(res));
            return res;
        }));
        const reported = (e) => {
            if (e.reason instanceof RequestError)
                e.preventDefault();
        };
        window.addEventListener('unhandledrejection', reported);
        return () => {
            removeInterceptor();
            window.removeEventListener('unhandledrejection', reported);
        };
    }, [toast]);
    const routingContext = {
        routingConfig: props.routingConfig,
        isAuthenticated: stateAuth.isAuthenticated,
        hasPermission: stateAuth.hasPermission,
        onSubdomain,
        matched: null,
        currentPath: routeCurrent.pieces
    };
    const availableRoutes = getAvailableRoutes(routingContext);
    const matched = findMatchingRoute(availableRoutes, routeCurrent);
    routingContext.matched = matched;
    // Each handler declares its own auth condition in `when`, so the auth state is not gated here.
    useEffect(() => {
        if (!matched) {
            executeInvalidAccessHandler(routingContext, navigate);
        }
    }, [matched, onSubdomain, stateAuth.isAuthenticated]);
    return (_jsx(ContextAuth.Provider, { value: { 'state': stateAuth, setToken, setContext }, children: _jsx(SavedPropertiesProvider, { children: _jsxs(NotImplementedProvider, { children: [__DEV__ && _jsx(ElementInspector, {}), matched !== null && matched !== void 0 ? matched : React.createElement(props.routingConfig.on404(routingContext), {})] }) }) }));
};
export default AppContent;
